import React, {useEffect} from "react";
import router from "./router";
import {RouterProvider} from "react-router-dom";
import MatomoTracker from "./components/Matomo";
import useRecaptcha from "./components/Hooks/Captcha";
import env from "./env";

// Pas de scripts tiers sur la console SAV : le login SAV y est saisi dans la page (SavLogin)
// et leur serait lisible. Aucun lien public ne mène à /console, on y arrive par son adresse.
const IS_CONSOLE = /^\/console(\/|$)/.test(window.location.pathname);

function ThirdPartyScripts() {
  useRecaptcha(env.CAPTCHA_KEY);

  useEffect(() => {
    if (document.getElementById("bugabot-script")) return;

    const script = document.createElement("script");
    script.id = "bugabot-script";
    script.src = "https://api.chatbot.bugali.io/widget/chatbot";
    script.async = true;

    document.body.appendChild(script);
  }, []);

  return <MatomoTracker />;
}

function App() {
  return (
    <>
      {!IS_CONSOLE && <ThirdPartyScripts />}
      <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
    </>
  );
}

export default App;
